import React, { Suspense } from 'react';

import { useUserCouponCount } from '~/domains/coupons/queries';

import styles from './CouponTooltip.module.css';

function CouponTooltipContent() {
  const couponCount = useUserCouponCount();
  if (!couponCount) return null;

  return (
    <div
      role="presentation"
      className={styles.wrapper}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      할인쿠폰이 있어요
    </div>
  );
}

function CouponTooltip() {
  return (
    <Suspense fallback={<></>}>
      <CouponTooltipContent />
    </Suspense>
  );
}

export default CouponTooltip;
